import { environment } from '../environments/environment';

/*
  App6 -> scaffolding migration (frameless hosted page, ID-1887).

  App6-first: the legacy Angular app boots immediately — nothing waits on
  this. In parallel we ask lambda-scaffolding's public
  `/should-scaffold/{embedId}` route (app6 embed + org feature flag +
  defdoc form wired — all checked server-side) and on a YES simply navigate
  the page to the scaffolding-hosted embed url, forwarding the query string
  AS-IS: the scaffolding page reads its params off its own location and
  ignores anything it doesn't consume.

  Never redirects when:
  - `force-legacy` is present in the url (explicit escape hatch),
  - a PayPal return leg is in flight (`donation`/`token`/`PayerID`) — that
    transaction must complete on the legacy app that started it,
  - the `scaffolding` config block ({embedBase, apiBase}) is absent from
    env_vars.json, or the probe errors/says no.
*/
export function MaybeRedirectToScaffolding(urlVars: { [key: string]: string }) {
  const embedId = urlVars['embed-id'];
  const scaffoldingConfig = environment && environment.scaffolding;
  const inPaypalReturnLeg = !!(urlVars['donation'] || urlVars['token'] || urlVars['PayerID']);
  if (
    !embedId ||
    urlVars['force-legacy'] ||
    inPaypalReturnLeg ||
    !scaffoldingConfig ||
    !scaffoldingConfig.embedBase ||
    !scaffoldingConfig.apiBase
  ) {
    return;
  }

  const trimSlash = (url: string) => url.replace(/\/+$/, '');
  fetch(`${trimSlash(scaffoldingConfig.apiBase)}/should-scaffold/${encodeURIComponent(embedId)}?cache-down=300`)
    .then(response => (response.ok ? response.json() : null))
    .then((body: { should_scaffold?: boolean } | null) => {
      if (body && body.should_scaffold === true) {
        window.location.replace(
          `${trimSlash(scaffoldingConfig.embedBase)}/embed/${encodeURIComponent(embedId)}${window.location.search}`
        );
      }
    })
    .catch(() => undefined);
}
